// MST
import { types } from 'mobx-state-tree'

// Helper
import { withHelper_questionSetModel } from './question-set.helper'

// Types
const { optional, array, model, maybeNull, number, string } = types

export const withHelper_competencyUnitProps = {
  competencyUnitId: maybeNull(number),
  competencyUnitCode: maybeNull(string),
  competencyUnitTitle: maybeNull(string),
  competencyUnitName: maybeNull(string),
  competentSummary: maybeNull(number),
  incompetentSummary: maybeNull(number),
  finishedCompetency: maybeNull(number),
  totalCompetency: maybeNull(number),
}

export const withHelper_competencyUnitModel = model('CompetencyUnit').props(withHelper_competencyUnitProps)

export const withHelper_competencyUnitQuestionSetModel = model('CompetencyUnitQuestionSet').props({
  ...withHelper_competencyUnitProps,
  questionSet: optional(array(withHelper_questionSetModel), []),
  feedbackNotes: maybeNull(string)
})
